<template>
  <div class="mission-ranking-self-not-ranked-parts">
    <div class="mission-ranking-self-not-ranked-parts__omitted">
      <p class="mission-ranking-self-not-ranked-parts__omitted-data">・・・</p>
    </div>
    <div class="mission-ranking-self-not-ranked-parts__self">
      <mission-ranking-table-item-parts
        :userData="selfData"
        :isOwnRank="isOwnRank"
        :retrieveNameUsersByUserId="retrieveNameUsersByUserId"
        :rankingType="rankingType"
        @onClickSnsButton="onClickSnsButton"
        @onClickShareIcon="onClickShareIcon"
        @savePostSnsMissionHistory="$emit('savePostSnsMissionHistory')"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import MissionRankingTableItemParts from '@/components/MissionPage/MissionRankingPane/parts/MissionRankingTableItemParts.vue'
import { RankInUserType } from '@/store/stores/collectionModule/documents/pointRanking/PointRankingDataDocument'
import { UserRetrieveNameResponseType } from '@/store/stores/collectionModule/documents/user/UserRetrieveNameDocument'
import { RankingType } from '@/store/stores/pageStore/MissionPage/MissionPageStore'

export default defineComponent({
  name: 'MissionRankingSelfNotRankedParts',
  components: {
    MissionRankingTableItemParts,
  },
  props: {
    selfData: {
      type: Object as PropType<RankInUserType>,
      required: true,
    },
    isOwnRank: {
      type: Boolean,
      default: false,
    },
    retrieveNameUsersByUserId: {
      type: Object as PropType<Record<string, UserRetrieveNameResponseType>>,
    },
    rankingType: {
      type: String as PropType<RankingType>,
      default: 'TOTAL',
    },
  },
  methods: {
    onClickSnsButton() {
      this.$emit('onClickSnsButton')
    },
    onClickShareIcon() {
      this.$emit('onClickShareIcon')
    },
  },
})
</script>

<style scoped lang="scss">
.mission-ranking-self-not-ranked-parts {
  &__omitted {
    padding: 10px 0;
    text-align: center;
    border-top: 1px solid $gray50;

    &-data {
      font-size: 14px;
      color: $white;
      line-height: 1.43;
      letter-spacing: 0.2em;
    }
  }
}
</style>
